// extracted by mini-css-extract-plugin
export default {"isCopied":"CopyToClipboard_isCopied__EyMmZ"};